<template>
  <view-container>
    <list-header :add="addButton">
      <v-col cols="12" :md="showClientFilter ? 4 : 6" v-if="showList">
        <search-field
          v-model="filter.search"
          placeholder="Фамилия или телефон"
        />
      </v-col>
      <v-col cols="12" :md="showList ? 4 : 12" v-if="showClientFilter">
        <reference-field
          v-model="filter.clientId"
          label="Клиент"
          reference="client"
        />
      </v-col>
      <v-col cols="12" :md="showClientFilter ? 4 : 6" v-if="showCompanyFilter">
        <reference-field
          v-model="filter.companyId"
          label="Компания"
          reference="company"
          :filter="companyFilter"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="showList">
        <v-switch
          class="ma-0"
          v-model="filter.active"
          label="только активные"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="client.maxCashiers">
        <v-progress-linear
          striped
          rounded
          :value="(activeCashiers / client.maxCashiers) * 100"
          color="accent"
        />
        <span class="grey--text"
          >активно {{ activeCashiers }} из {{ client.maxCashiers }}</span
        >
      </v-col>
    </list-header>
    <v-card v-if="showList">
      <v-list three-line>
        <template v-for="(item, index) in filteredItems">
          <v-divider :key="index" v-if="index > 0" />
          <div :key="item.id">
            <v-list-item
              :to="{ name: 'cashier-edit', params: { id: item.id } }"
              :class="itemClass(item)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
                <v-list-item-subtitle v-text="getSubtitle(item)" />
                <v-list-item-subtitle>
                  {{ item.phoneNumber | phone }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text
                  v-if="!user.clientId && item.client"
                  v-text="item.client.name"
                />
                <v-list-item-action-text
                  v-if="item.group && item.group.company"
                  v-text="item.group.company.name"
                />
                <v-list-item-action-text
                  class="d-none d-sm-flex blue--text"
                  v-if="item.lastOrderTime"
                >
                  последний чек:&nbsp;&nbsp;
                  <span class="font-weight-bold">{{ item.lastOrderTime }}</span>
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="d-flex d-sm-none height-20" inactive>
              <v-list-item-content class="pt-0">
                <v-list-item-subtitle
                  v-if="item.lastOrderTime"
                  class="blue--text"
                >
                  последний чек:&nbsp;&nbsp;{{ item.lastOrderTime }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <data-loader :watch="filter" :load="load" v-model="items" />
      </v-list>
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import moment from "moment";
import Vue from "vue";
export default {
  name: "CashierList",
  props: {
    clientId: String
  },
  data() {
    return {
      items: [],
      filter: {
        search: "",
        clientId: null,
        companyId: null,
        active: true
      },
      client: {},
      activeCashiers: 0
    };
  },
  computed: {
    addButton() {
      return !this.user.isPartner
        ? { name: "cashier-new", params: { clientId: this.filter.clientId } }
        : null;
    },
    user() {
      return this.$store.getters["auth/getUser"];
    },
    companyFilter() {
      return { clientId: this.filter.clientId };
    },
    showClientFilter() {
      return !this.user.clientId;
    },
    showCompanyFilter() {
      return this.filter.clientId || this.user.clientId;
    },
    showList() {
      return this.user.isPartner ? this.filter.clientId : true;
    },
    filteredItems() {
      let items = this.filter.clientId
        ? this.items.filter(item => item.clientId == this.filter.clientId)
        : this.items;
      return items.filter(item => !this.filter.active || item.active);
    }
  },
  watch: {
    "filter.clientId": async function(newVal, oldVal) {
      if (this.user.clientId) {
        this.$store.commit("setTitle", "Кассиры");
        return;
      }
      if (newVal != oldVal) {
        this.loadClientInfo();
        if (newVal) {
          let client = await ds.find("client", this.filter.clientId);
          this.$store.commit("setTitle", "Кассиры " + client.name);
        } else {
          this.$store.commit("setTitle", "Кассиры");
        }
        this.filter.search = "";
        this.filter.companyId = null;
      }
      this.user.isPartner && this.$store.commit("setClientId", newVal);
    }
  },
  activated() {
    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }
    this.loadClientInfo();
  },
  created() {
    ds.on("afterCreate", (mapperName, props, opts, result) => {
      mapperName === "cashier" &&
        this.items.unshift(result) &&
        this.loadClientInfo();
    });
    ds.on("afterUpdate", mapperName => {
      mapperName === "cashier" && this.loadClientInfo();
    });
  },
  methods: {
    itemClass(item) {
      return item.active ? "" : "inactive";
    },
    getSubtitle(item) {
      let val = item.title;
      if (item.itemGroup) {
        val += ", " + item.itemGroup.name;
      }
      return val;
    },
    async loadClientInfo() {
      let clientId =
        this.user.clientId || this.clientId || this.filter.clientId;
      if (clientId) {
        this.client = await ds.find("client", clientId);
        if (this.client.maxCashiers > 0) {
          this.activeCashiers = (await this.client.countActiveCashiers()) || 0;
        }
      } else {
        this.client = {};
      }
    },
    async load(pager) {
      let items = await ds.findAll("cashier", { ...pager, ...this.filter });
      let rels =
        !this.filter.clientId && !this.user.clientId
          ? ["client", "itemGroup"]
          : ["group", "group.company", "itemGroup"];
      items.forEach(item => {
        item.loadRelations(rels);
        ds.findAll("order", {
          limit: 1,
          offset: 0,
          cashierId: item.id
        }).then(result =>
          Vue.set(
            item,
            "lastOrderTime",
            result && result.length
              ? moment(result[0].createdAt).format("DD.MM.YYYY hh:mm:ss")
              : " - "
          )
        );
      });
      return items;
    }
  }
};
</script>

<style lang="stylus" scoped>
.height-20
   min-height: 20px
</style>
